import { createContext, Dispatch, ReactNode, useContext, useState } from "react"

interface NavBarContextInterface {
  isHovered: boolean
  setIsHovered: Dispatch<React.SetStateAction<boolean>>
}

// Create Context
const NavBarContext = createContext({} as NavBarContextInterface)

// Provider Component
export const NavBarProvider = ({ children }: { children: ReactNode }) => {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <NavBarContext.Provider value={{ isHovered, setIsHovered }}>
      {children}
    </NavBarContext.Provider>
  )
}

// Custom hook to use context
// eslint-disable-next-line react-refresh/only-export-components
export function useNavBarContext() {
  const appContext = useContext(NavBarContext)
  if (appContext === undefined) {
    throw new Error("useNavBarContext must be used within a NavBarProvider")
  }
  return appContext
}
